import { HasId } from '../../interfaces';

export class OrganizationTypeahead implements HasId {
    public id: number;
    public name: string;
}


// WEBPACK FOOTER //
// ./src/models/typeaheads/OrganizationTypeahead.tsx